const amenitiesFilterOptions = [
	{
		label: "Alarm",
		value: "alarm"
	},
	{
		label: "Climate Controlled",
		value: "climateControlled"
	},
	{
		label: "Drive Up Access",
		value: "driveUp"
	},
	{
		label: "1st Floor",
		value: "firstFloor"
	},
	{
		label: "24-Hour Access",
		value: "twentyFourHourAccess"
	},
	{
		label: "Free Truck Rental",
		value: "freeTruckRental"
	},
	{
		label: "Open Now",
		value: "openNow"
	}
];

const amenitiesFilterOptionsV2 = [
	{
		label: "24 Hour Storage Units",
		value: "twentyFourHourAccess"
	},
	{
		label: "Climate Controlled Storage Units",
		value: "climateControlled"
	},
	{
		label: "Contactless Storage Units",
		value: "hasContactlessMoveins"
	},
	{
		label: "Drive Up Storage Units",
		value: "driveUp"
	},
	{
		label: "Gated Storage Units",
		value: "eGateAccess"
	},
	{
		label: "Secure Storage Units",
		value: "cameras"
	},
	{
		label: "Elevator Access Storage Units",
		value: "elevator"
	},
	{
		label: "First-Floor Storage Units",
		value: "firstFloor"
	},
	{
		label: "Storage Units with Truck Rental",
		value: "freeTruckRental"
	},
	{
		label: "Online Move-In",
		value: "hasOnlineMoveins"
	},
	{
		label: "Self-Service Storage Units",
		value: "kiosk"
	},
	{
		label: "Storage Units with Electricity",
		value: "power"
	},
	{
		label: "Wine Storage Units",
		value: "onlyWine"
	}
];

const unitSizeFilterOptions = [
	{
		label: "5' x 5'",
		value: "0-25"
	},
	{
		label: "5' x 10'",
		value: "26-60"
	},
	{
		label: "5' x 15'",
		value: "61-75"
	},
	{
		label: "10' x 10'",
		value: "76-100"
	},
	{
		label: "10' x 15'",
		value: "101-150"
	},
	{
		label: "10' x 20'",
		value: "151-200"
	},
	{
		label: "10' x 25'",
		value: "201-250"
	},
	{
		label: "10' x 30'",
		value: "251-300"
	}
];

const unitSizeFilterOptionsV2 = [
	{
		label: "5x5 Storage Units",
		value: "0-25"
	},
	{
		label: "5x10 Storage Units",
		value: "26-60"
	},
	{
		label: "5x15 Storage Units",
		value: "61-75"
	},
	{
		label: "10x10 Storage Units",
		value: "76-100"
	},
	{
		label: "10x15 Storage Units",
		value: "101-150"
	},
	{
		label: "10x20 Storage Units",
		value: "151-200"
	},
	{
		label: "10x25 Storage Units",
		value: "201-250"
	},
	{
		label: "10x30 Storage Units",
		value: "251-300"
	},
	{
		// isLocker sends onlyLocker=true instead of a sqft value.
		label: "Locker Storage Units",
		value: "onlyLocker",
		isLocker: true
	},
	{
		label: "Mini Storage Units",
		value: "mini"
	}
];

// `value` maps to the vehicleAccommodation query param and must match the slugs ssdr/reactfoot send.
const vehicleStorageFilterOptions = [
	{
		label: "Boat Storage Units",
		value: "boat-storage",
		vehicle: "boat"
	},
	{
		label: "Car Storage Units",
		value: "car-storage",
		vehicle: "car"
	},
	{
		label: "RV Storage Units",
		value: "rv-storage",
		vehicle: "rv"
	},
	{
		label: "Covered Outdoor Storage Units",
		value: "outdoor-covered"
	},
	{
		label: "Uncovered Outdoor Storage Units",
		value: "outdoor-uncovered"
	}
];

// `value` maps to the minLength query param, `maxLength` to maxLength.
const vehicleSizeFilterOptions = [
	{ label: "15' Long", value: "15", maxLength: "19.99" },
	{ label: "20' Long", value: "20", maxLength: "24.99" },
	{ label: "25' Long", value: "25", maxLength: "29.99" },
	{ label: "30' Long", value: "30", maxLength: "34.99" },
	{ label: "35' Long", value: "35", maxLength: "39.99" },
	{ label: "40' Long", value: "40", maxLength: "49.99" },
	{ label: "50' Long", value: "50", maxLength: "999" }
];

export const FILTER_GROUPS = {
	AMENITIES: "amenities",
	UNIT_SIZE: "sqft",
	VEHICLE_STORAGE: "vehicleStorage",
	VEHICLE_SIZE: "vehicleSize"
};

const optionsByValue = (options, filterGroupKey) =>
	options.reduce(
		(acc, { label, value, vehicle, maxLength, isLocker }) => ({
			...acc,
			[value]: {
				label,
				checked: false,
				name: filterGroupKey,
				value,
				...(vehicle && { vehicle }),
				...(maxLength && { maxLength }),
				...(isLocker && { isLocker })
			}
		}),
		{}
	);

const defaultFilterOptions = {
	[FILTER_GROUPS.AMENITIES]: {
		label: "Amenities Filters",
		type: "checkbox",
		multiple: true,
		options: optionsByValue(amenitiesFilterOptions, FILTER_GROUPS.AMENITIES)
	},
	[FILTER_GROUPS.UNIT_SIZE]: {
		label: "Unit Size Filters",
		type: "checkbox",
		multiple: false,
		options: optionsByValue(unitSizeFilterOptions, FILTER_GROUPS.UNIT_SIZE)
	}
};

export const SORT_TYPES = {
	recommended: {
		label: "Recommended",
		value: "CronutNVF100DonutsLowLTV"
	},
	price: {
		label: "Price",
		value: "price"
	},
	distance: {
		label: "Distance",
		value: "distance"
	},
	reviews: {
		label: "Reviews",
		value: "reviews"
	}
};

export const searchV2FilterOptions = {
	[FILTER_GROUPS.AMENITIES]: {
		label: "Amenities Filters",
		type: "checkbox",
		multiple: true,
		options: optionsByValue(
			amenitiesFilterOptionsV2,
			FILTER_GROUPS.AMENITIES
		)
	},
	[FILTER_GROUPS.UNIT_SIZE]: {
		label: "Size Filters",
		type: "checkbox",
		multiple: true,
		options: optionsByValue(
			unitSizeFilterOptionsV2,
			FILTER_GROUPS.UNIT_SIZE
		)
	},
	[FILTER_GROUPS.VEHICLE_STORAGE]: {
		label: "Vehicle Storage Filters",
		type: "radio",
		multiple: false,
		options: optionsByValue(
			vehicleStorageFilterOptions,
			FILTER_GROUPS.VEHICLE_STORAGE
		)
	},
	[FILTER_GROUPS.VEHICLE_SIZE]: {
		label: "Size",
		type: "radio",
		multiple: false,
		options: optionsByValue(
			vehicleSizeFilterOptions,
			FILTER_GROUPS.VEHICLE_SIZE
		)
	}
};

// Match on an option's `name`, not label — both size groups display as "Size".
export const getFilterGroupKey = (group) =>
	Object.values(group?.options || {})[0]?.name ?? null;

export const findFilterGroup = (groups, groupKey) =>
	(groups || []).find((group) => getFilterGroupKey(group) === groupKey) ??
	null;

export const defaultSort = SORT_TYPES.recommended.value;

export default defaultFilterOptions;
